"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.thicknessEqualityComparer = exports.rangeEqualityComparer = exports.rectEqualityComparer = exports.sizeEqualityComparer = exports.pointEqualityComparer = exports.deepEqualityComparer = void 0;
var isEqual = require("lodash/fp/isEqual");
function deepEqualityComparer(a, b) {
    return isEqual(a, b);
}
exports.deepEqualityComparer = deepEqualityComparer;
function pointEqualityComparer(a, b) {
    return a.x === b.x && a.y === b.y;
}
exports.pointEqualityComparer = pointEqualityComparer;
function sizeEqualityComparer(a, b) {
    return a.width === b.width && a.height === b.height;
}
exports.sizeEqualityComparer = sizeEqualityComparer;
function rectEqualityComparer(a, b) {
    return sizeEqualityComparer(a, b) && pointEqualityComparer(a, b);
}
exports.rectEqualityComparer = rectEqualityComparer;
function rangeEqualityComparer(a, b) {
    return a.start === b.start && a.end === b.end;
}
exports.rangeEqualityComparer = rangeEqualityComparer;
function thicknessEqualityComparer(a, b) {
    return a.left === b.left && a.top === b.top && a.right === b.right && a.bottom === b.bottom;
}
exports.thicknessEqualityComparer = thicknessEqualityComparer;
//# sourceMappingURL=EqualityComparers.js.map